/**
 * Takes either a scale + accessor or a `zGet` function and converts it into a `zGet` function
 * @param props
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function anyGetter(props) {
    if ('get' in props)
        return props.get;
    return (datum) => props.scale(props.accessor(datum));
}
